import { organizationConstants } from '../constants';
import { organizationService } from '../services';
import { showToast } from '../services/toast';

export const organizationActions = {
    fetchBranding,
    updateBranding,
};

function applyDocumentTitle(branding) {
    if (branding?.CMS_BROWSER_TITLE) {
        document.title = branding.CMS_BROWSER_TITLE;
    }
}

function fetchBranding() {
    return (dispatch) => {
        dispatch(request());

        return organizationService
            .fetchBranding()
            .then(
                (response) => {
                    const branding = response?.data || {};
                    applyDocumentTitle(branding);
                    dispatch(success(branding));
                    return branding;
                },
                (error) => {
                    dispatch(failure(error));
                    return Promise.reject(error);
                }
            );
    };

    function request() {
        return { type: organizationConstants.FETCH_BRANDING_REQUEST };
    }
    function success(branding) {
        return { type: organizationConstants.FETCH_BRANDING_SUCCESS, branding };
    }
    function failure(error) {
        return { type: organizationConstants.FETCH_BRANDING_FAILURE, error };
    }
}

function updateBranding(brandingDetails) {
    return (dispatch) => {
        dispatch(request());

        return organizationService
            .updateBranding(brandingDetails)
            .then(
                (response) => {
                    const branding = response?.data || {};
                    applyDocumentTitle(branding);
                    dispatch(success(branding));
                    showToast(response?.responseMessage || 'Branding updated successfully', 'success');
                    return branding;
                },
                (error) => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) {
                        showToast(error?.message || error.toString(), 'error');
                    }
                    return Promise.reject(error);
                }
            );
    };

    function request() {
        return { type: organizationConstants.UPDATE_BRANDING_REQUEST };
    }
    function success(branding) {
        return { type: organizationConstants.UPDATE_BRANDING_SUCCESS, branding };
    }
    function failure(error) {
        return { type: organizationConstants.UPDATE_BRANDING_FAILURE, error };
    }
}
